import { StyledDefsSvg } from './SpinnerGradientDefs.styled';

export const SPINNER_GRADIENT_ID = 'aiAssistantSpinnerGradient';

export const SpinnerGradientDefs = (): JSX.Element => (
   <StyledDefsSvg aria-hidden='true' focusable='false'>
      <defs>
         <linearGradient id={SPINNER_GRADIENT_ID} x1='0' y1='0' x2='0' y2='1'>
            <stop offset='0%' stopColor='#8946D4' />
            <stop offset='100%' stopColor='#2879BD' />
         </linearGradient>
      </defs>
   </StyledDefsSvg>
);
